import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import ptBRJson from './translations/ptBR.json'
import enJson from './translations/en.json'
import esJson from './translations/es.json'

export const I18N_STORAGE_KEY = 'i18nextLng'
export const I18N_MANUAL_STORAGE_KEY = 'i18nextLngUserChoice'

export function getLanguageFromBrowser() {
  const browserLanguages =
    typeof navigator !== 'undefined' && navigator.languages?.length
      ? [...navigator.languages]
      : typeof navigator !== 'undefined' && navigator.language
        ? [navigator.language]
        : []

  for (const lang of browserLanguages) {
    const normalized = lang.toLowerCase()

    if (normalized.startsWith('pt')) return 'ptBR'
    if (normalized.startsWith('es')) return 'es'
    if (normalized.startsWith('en')) return 'en'
  }

  return 'en'
}

export function getStripeLanguage() {
  if (typeof window === 'undefined') {
    return 'ptBR'
  }

  return localStorage.getItem(I18N_STORAGE_KEY) || i18n.language || 'ptBR'
}

const resources = {
  en: enJson,
  ptBR: ptBRJson,
  es: esJson,
};

const isManualLanguage = localStorage.getItem(I18N_MANUAL_STORAGE_KEY) === 'true'
const savedLanguage = localStorage.getItem(I18N_STORAGE_KEY)
const autoLanguage = getLanguageFromBrowser()
const defaultLanguage =
  isManualLanguage && savedLanguage ? savedLanguage : autoLanguage

if (!isManualLanguage) {
  localStorage.setItem(I18N_STORAGE_KEY, autoLanguage)
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: defaultLanguage, // Usa a linguagem salva ou o valor padrão
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
